import * as t from 'io-ts';
import { LegDynamicType } from 'acscp/api/models/leg';

export const TripDynamicType = t.type({
    legs: t.array(LegDynamicType),
    tripNumber: t.number,
    additionalComments: t.union([t.string, t.null]),
    sellPrice: t.union([t.number, t.null]),
    identifier: t.union([t.string, t.null]),
    includeNumber: t.boolean,
});

export type Trip = t.TypeOf<typeof TripDynamicType>;
